// Modules
import {useState} from "react";

// Types
import { UserInfo } from "interfaces/userInfo";

// Components
import LoginModal from "components/Header/LoginModal";
import Header from "components/Header/Header";

interface HeaderContentProps {
    userInfo: UserInfo
    APISSOCallCompleted: boolean;
}

const HeaderContent = ({userInfo, APISSOCallCompleted}: HeaderContentProps) => {
    const [isProfileOpen, setIsProfileOpen] = useState(false);
    const [isModalOpened, setIsModalOpened] = useState(false);

    return (
        <>
            <Header userInfo={userInfo} isProfileOpen={isProfileOpen} setIsProfileOpen={setIsProfileOpen}
                    setIsModalOpened={setIsModalOpened} APISSOCallCompleted={APISSOCallCompleted}/>
            <LoginModal isLogged={userInfo.isLogged} isModalOpened={isModalOpened}
                        setIsModalOpened={setIsModalOpened}/>
        </>
    )
};

export default HeaderContent;